import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { LoopInfoParams, LoopVaultInfo } from "@bridgesplit/abf-sdk";
import { percentUiToDecimals } from "@bridgesplit/utils";

import { abfSerializeQueryArgs, marketsPublicBaseQuery } from "./util";
import {
    GET_LOOP_VAULTS_INFO_ROUTE,
    ROUTE_UPDATE_COLLATERAL_YIELD_UPDATE,
    ROUTE_GET_LATEST_COLLATERAL_YIELD_PCTS
} from "../constants";

const LOOP_PUBLIC_TAG = "LoopPublic";
export const loopPublicApi = createApi({
    reducerPath: "loopApiPublic",
    tagTypes: [LOOP_PUBLIC_TAG],
    baseQuery: marketsPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,

    endpoints: (builder) => ({
        loopInfos: builder.query<{ [loopVaultAddress: string]: LoopVaultInfo }, LoopInfoParams>({
            query: (body) => ({
                url: GET_LOOP_VAULTS_INFO_ROUTE,
                method: "POST",
                body
            }),
            transformResponse: (response: {
                [loopVaultAddress: string]: Omit<LoopVaultInfo, "tags"> & { tags: string };
            }) => {
                return Object.fromEntries(
                    Object.entries(response).map(([key, value]) => {
                        return [key, { ...value, tags: value.tags ? JSON.parse(value.tags) : [] }];
                    })
                );
            }
        }),
        loopCollateralYieldLatestByMints: builder.query<Record<string, number>, string[]>({
            providesTags: [LOOP_PUBLIC_TAG],
            transformResponse: (response: Record<string, number>) => {
                return Object.fromEntries(
                    Object.entries(response).map(([key, value]) => {
                        return [key, percentUiToDecimals(value)];
                    })
                );
            },
            query: (mints) => ({
                url: ROUTE_GET_LATEST_COLLATERAL_YIELD_PCTS,
                method: "POST",
                body: mints
            })
        }),
        loopCollateralYieldUpdate: builder.mutation<void, void>({
            query: () => ({
                url: ROUTE_UPDATE_COLLATERAL_YIELD_UPDATE,
                method: "POST"
            })
        })
    })
});

export const { useLoopInfosQuery, useLoopCollateralYieldLatestByMintsQuery } = loopPublicApi;

export const useLoopPublicApi = () => {
    const dispatch = useDispatch();

    return {
        resetLoopApiPublic: () => dispatch(loopPublicApi.util.invalidateTags([LOOP_PUBLIC_TAG]))
    };
};
